import React, {Component} from 'react';
import FaShoppingCart from 'react-icons/lib/fa/shopping-cart';
import FaFacebookOfficial from 'react-icons/lib/fa/facebook-official';
import FaTwitterSquare from 'react-icons/lib/fa/twitter-square';
import FaInstagram from 'react-icons/lib/fa/instagram';
import FaPinterestSquare from 'react-icons/lib/fa/pinterest-square';
import FaBarIcon from 'react-icons/lib/fa/bars';

class FaMenuBarIcon extends Component {
  render() {
    return React.createElement(
      'h3',
      null,
      React.createElement(FaBarIcon, null),
    );
  }
}

class FaCartIcon extends Component {
  render() {
    return React.createElement(
      'h3',
      null,
      React.createElement(FaShoppingCart, null),
    );
  }
}

class FaFacebookIcon extends Component {
  render() {
    return (
      <h3 style={{display: 'inline-block'}}>
        {React.createElement(FaFacebookOfficial, null)}
      </h3>
    );
  }
}

class FaTwitterIcon extends Component {
  render() {
    return (
      <h3 style={{display: 'inline-block'}}>
        {React.createElement(FaTwitterSquare, null)}
      </h3>
    );
  }
}

class FaInstagramIcon extends Component {
  render() {
    return (
      <h3 style={{display: 'inline-block'}}>
        {React.createElement(FaInstagram, null)}
      </h3>
    );
  }
}

class FaPinterestIcon extends Component {
  render() {
    return (
      <h3 style={{display: 'inline-block'}}>
        {React.createElement(FaPinterestSquare, null)}
      </h3>
    );
  }
}

export default {
  FaCartIcon: FaCartIcon,
  FaFacebookIcon: FaFacebookIcon,
  FaPinterestIcon: FaPinterestIcon,
  FaInstagramIcon: FaInstagramIcon,
  FaTwitterIcon: FaTwitterIcon,
  FaMenuBarIcon: FaMenuBarIcon,
};



// WEBPACK FOOTER //
// ./src/components/Icon.js